import { requestActions } from "./utils";

export const INFO = requestActions("Info/Get");
